var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.235,
    height: 50.235,
    viewBox: "0 0 50.235 50.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14266",
    "data-name": "Group 14266",
    transform: "translate(-659 -170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "options_button",
    transform: "translate(659 170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13183",
    "data-name": "Group 13183"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_786",
    "data-name": "Ellipse 786",
    cx: 22.912,
    cy: 22.912,
    rx: 22.912,
    ry: 22.912,
    transform: "translate(2.205 2.205)",
    fill: "#ffcf03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24374",
    "data-name": "Path 24374",
    d: "M1611.907,1519.386A22.912,22.912,0,1,1,1589,1542.3a22.912,22.912,0,0,1,22.912-22.912m0-2.205a25.117,25.117,0,1,0,25.118,25.117,25.146,25.146,0,0,0-25.118-25.117Z",
    transform: "translate(-1586.79 -1517.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24375",
    "data-name": "Path 24375",
    d: "M1626.8,1595.008c-14.247,0-26.314-6.951-30.466-16.557a22.9,22.9,0,1,0,43.379,14.526A41.3,41.3,0,0,1,1626.8,1595.008Z",
    transform: "translate(-1592.584 -1561.56)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_airplay",
    "data-name": " airplay",
    transform: "translate(334.146 -723.056)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_6",
    "data-name": "Rectangle Copy 6",
    width: 24,
    height: 24,
    transform: "translate(338 906)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M353.58,928h-7.17a.982.982,0,0,1-.919-.613.993.993,0,0,1,.209-1.1l3.59-3.59a1,1,0,0,1,1.41,0l3.59,3.59a1,1,0,0,1-.71,1.71Zm5.42-3h-3a1,1,0,0,1,0-2h2a1,1,0,0,0,1-1V912a1,1,0,0,0-1-1H342a1,1,0,0,0-1,1v10a1,1,0,0,0,1,1h2a1,1,0,0,1,0,2h-3a2,2,0,0,1-2-2V911a2,2,0,0,1,2-2h18a2,2,0,0,1,2,2v12A2,2,0,0,1,359,925Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.e7364ea8f5fc00c2d297eae6c7f83161.svg";
export { ForwardRef as ReactComponent };